  <div class="le-component">
    <div class="le-step-content">
      <div class="le-form-container">
        <div class="le-search-field-content">
          <div class="le-search-field-row">
            <div class="le-search-field-active-column">
              <div class="mydocma-form">
                <mat-slide-toggle matInput [checked]="(isAssignedAll$ | async)" (toggleChange)="onActiveAllToggled()">
                </mat-slide-toggle>
              </div>
            </div>
            <div class="le-search-field-search-column">
              <mydocma-search-field [options]="searchOptions">
              </mydocma-search-field>
            </div>
            <div class="le-search-field-menu-column">
              <button mat-icon-button [matMenuTriggerFor]="tagLayoutFieldsMenu" class="search-field-menu_moreHoriz"
                      (click)="$event.stopPropagation()">
                <mydocma-custom-mat-icon [iconName]="'more_horiz'"></mydocma-custom-mat-icon>
              </button>
            </div>
          </div>
        </div>

        <mydocma-grid #grid class="ag-theme-alpine mydocma-ag-grid le-grid"
          [gridOptions]="gridOptions">
        </mydocma-grid>

        <mat-menu #tagLayoutFieldsMenu="matMenu">
          <button mat-menu-item (click)="onScopeClick(fieldDisplayColumns.Prop)" style="padding-right: 0px">
            <span>{{'MM.layout.fields.showSystemFieldNames' | translate}}</span>
            <mydocma-custom-mat-icon *ngIf="(currentFieldDisplayColumns$ | async) === fieldDisplayColumns.Prop" [iconName]="'check'" style="margin-left: 10px; padding-right: 0px !important;"></mydocma-custom-mat-icon>
          </button>
          <button mat-menu-item (click)="onScopeClick(fieldDisplayColumns.Global)" style="padding-right: 0px">
            <span>{{'MM.layout.fields.showGlobalFieldNames' | translate}}</span>
            <mydocma-custom-mat-icon *ngIf="(currentFieldDisplayColumns$ | async) === fieldDisplayColumns.Global" [iconName]="'check'" style="margin-left: 10px; padding-right: 0px !important;"></mydocma-custom-mat-icon>
          </button>
          <button mat-menu-item (click)="onScopeClick(fieldDisplayColumns.Project)" style="padding-right: 0px">
            <span>{{'MM.layout.fields.showProjectFieldNames' | translate}}</span>
            <mydocma-custom-mat-icon *ngIf="(currentFieldDisplayColumns$ | async) === fieldDisplayColumns.Project" [iconName]="'check'" style="margin-left: 10px; padding-right: 0px !important;"></mydocma-custom-mat-icon>
          </button>
        </mat-menu>

      </div>
    </div>
  </div>
